<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{name: 'Dashboard', icon: 'fa fa-home', path: '/dashboard', visible: true}"
        ></sidebar-item>
        <sidebar-item
          :link="{name: 'Nivelamento', icon: 'fa fa-play', path: '/courses', visible: true}"
        ></sidebar-item>
        <sidebar-item
          :link="{name: 'Trading System', icon: 'fas fa-user-clock', path: '/fullcalendar_trading_system', visible: (!$auth.user().trading_system) && $auth.user().watched_all_videos && ($auth.user().plan_type_code == 'PREMIUM')}"
        ></sidebar-item>
        <sidebar-item
          :link="{name: 'Grupo de Estudo ao Vivo', icon: `${icon}`, path: '/conferenceroom', visible: $auth.user().conference_room_access}"
        ></sidebar-item>
        <sidebar-item
          :link="{name: 'Especialização', icon: 'fa fa-globe', path: '/workshop', visible: $auth.user().workshop_access}"
        ></sidebar-item>
        <sidebar-item
          :link="{name: 'Ferramentas', icon: 'fa fa-chart-bar', path: '/performance', visible: true}"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :class="'main-'+theme">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import moment from "moment-timezone";

moment.tz.setDefault("America/Sao_Paulo");
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu
  },
  data() {
    return {
      conferenceRoomSchedules: [],
      conferenceRoomButton: []
    };
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    },
    icon () {
      const found = this.conferenceRoomButton.find(nextConf => nextConf === true);
      if (found === undefined) {
        return 'fa fa-circle'
      }
      return 'fa fa-circle heart'
    }
  },
  created () {
    this.fetchTodaysUserConferenceRoomSchedules();
    // console.log(this.icon, this.conferenceRoomButton)
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    fetchTodaysUserConferenceRoomSchedules() {
      this.axios
        .get("/todaysconferenceroomschedules?include=conferenceRoom")
        .then(response => {
          this.conferenceRoomSchedules = response.data.data;
          if (this.conferenceRoomSchedules) {
            this.setButton();
          }
        })
        .catch(error => {
          console.log(error);
          alert(
            "Erro ao carregar os grupos de estudos de hoje. Tente novamente \n. " + error
          );
        });
    },
    setButton() {
      for (let conferenceRoomSchedule of this.conferenceRoomSchedules) {
        // Conference Room DateTime
        let dateHourConferenceRoom = moment.tz("America/Sao_Paulo");
        dateHourConferenceRoom.set({
          hour: conferenceRoomSchedule.daily_time.split(":")[0],
          minute: conferenceRoomSchedule.daily_time.split(":")[1],
          second: "00"
        });

        // DateTime Now
        let dateNow = moment.tz("America/Sao_Paulo").toDate();

        // Calculate Time Difference between now and conference room time.
        let diff =
          (dateNow.getTime() - dateHourConferenceRoom.toDate().getTime()) /
          1000;
        diff /= 60 * 60;

        if (diff >= -1 && diff <= 3.8) {
          // "Sala Disponível";
          this.conferenceRoomButton.push(true);
        } else {
          this.conferenceRoomButton.push(false);
        }
      }
    },
  }
};
</script>
<style lang="scss">

.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
.main-black {
  background: #0b0c0d;
  color: #d8d8d8;
}
.main-light {
  background: #d8d8d8;
  color: #03141e;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/DashboardLayout.vue